import { CommonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const SearchTeamsData = (filterObject, sortBy, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...'
    };
    setState(newState);

    let filterObjectString = JSON.stringify(filterObject)
    const sortByValue = sortBy !== undefined && sortBy.length > 0 ? sortBy : 'orgUnitName';
    const filterObjectForUrl = filterObjectString ? encodeURIComponent(filterObjectString) : 'NaN';
    filterObjectForUrl.replace('&', '%26');
    const url = `/OrgUnit/OtherOrganization/search?filters=${filterObjectForUrl}&sortBy=${sortByValue}`;
    CommonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData: arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default SearchTeamsData;